module.exports = __webpack_public_path__ + "img/top_icon04.abbc002.png";